<template>
  <div>
    <nav class="navbar-light text-left text-smallest font-weight-bold shadow side-nav mr-2"
         style="width: 152px;">
      <ul class="nav flex-column h-100p text-left">
        <li class="nav-item">
          <router-link
              :to="{name: 'MedicalIncidents'}"
              tag="a"
              class="nav-link text-dark"
              :class="{'active': isActiveRoute('MedicalIncidents')}"
              role="tab"
              data-toggle="list"
          >
            Medical Incidents
          </router-link>
        </li>
<!--        <li class="nav-item">-->
<!--          <router-link-->
<!--              :to="{name: 'DrugAlcoholTest'}"-->
<!--              tag="a"-->
<!--              class="nav-link text-dark"-->
<!--              :class="{'active': isActiveRoute('DrugAlcoholTest')}"-->
<!--              role="tab"-->
<!--              data-toggle="list"-->
<!--          >-->
<!--            Drug & Alcohol Test-->
<!--          </router-link>-->
<!--        </li>-->
        <li class="nav-item">
          <router-link
              :to="{name: 'PandI'}"
              tag="a"
              class="nav-link text-dark"
              :class="{'active': isActiveRoute('PandI')}"
              role="tab"
              data-toggle="list"
          >
            P & I
          </router-link>
        </li>
<!--        <li class="nav-item">-->
<!--          <router-link-->
<!--              :to="{name: 'MaintenanceMedicines'}"-->
<!--              tag="a"-->
<!--              class="nav-link text-dark"-->
<!--              :class="{'active': isActiveRoute('MaintenanceMedicines')}"-->
<!--              role="tab"-->
<!--              data-toggle="list"-->
<!--          >-->
<!--            Maintenance Medicines-->
<!--          </router-link>-->
<!--        </li>-->
      </ul>
    </nav>

    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { vueAppMixin } from '@/mixins/vueAppMixin';
export default {
  name: "MedicalIssues",
  mixins: [ vueAppMixin ],
}
</script>

<style scoped>
.nav-link.active, .nav-link:hover {
  background-color: #e87c87;
  color: white !important;
}
</style>